"use client";

import Link from "next/link";
import { Button } from "@/components/ui/button";
import { trackEvent } from "@/lib/analytics";

export function HomeHeroCTA() {
  return (
    <div className="flex flex-col sm:flex-row gap-4 justify-center">
      <Link href="/login">
        <Button
          size="lg"
          className="bg-purple-600 hover:bg-purple-700 text-lg px-8 py-6 h-auto"
          onClick={() => trackEvent("hero_cta_click", { cta: "start_free_trial" })}
        >
          Start Free Trial
        </Button>
      </Link>
      <Link href="/pricing">
        <Button size="lg" variant="outline" className="text-lg px-8 py-6 h-auto">
          View Plans
        </Button>
      </Link>
    </div>
  );
}
